import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestioneTableComponent } from './components/gestione-posizioni-table/gestione-posizioni-table.component';
import { MuoviPosizioneDialogComponent } from './components/muovi-posizione-dialog/muovi-posizione-dialog.component';
import { GestionePosizioniComponent } from './gestione-posizioni.component';
import { AuthModule } from 'src/app/auth/auth.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    CalendarModule,
    TreeTableModule,
    SharedModule,
    AutoCompleteModule,
    AuthModule
  ],
  exports: [
    GestionePosizioniComponent
  ],
  declarations: [
    GestionePosizioniComponent,
    GestioneTableComponent,
    MuoviPosizioneDialogComponent,
  ],
  providers: [],
})
export class GestionePosizioniModule { }
